import { render, staticRenderFns } from "./RoomSkeleton.vue?vue&type=template&id=412cab76"
import script from "./RoomSkeleton.vue?vue&type=script&lang=js"
export * from "./RoomSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports